import { IdvForm, IdvFormType } from '@/components/idv/IdvForm';
import IdvIntro from '@/components/idv/IdvIntro';
import { useIdvContext } from '@/components/idv/IdvProvider';
import { useModal } from '@/components/ModalManager';
import { useTrackPageViewed } from '@/services/analytics/useTracking';
import { digitsFromStr } from '@common/util/strings';
import { IdvIntroDisclosure } from '../IdvIntroDisclosure';

type T = IdvFormType<undefined, 'firstName' | 'lastName' | 'phone' | 'dob'>;

export const ProfileView = () => {
    const { title, subtitle } = useIdvContext();
    const modal = useModal();
    useTrackPageViewed('IDV > ProfileView');

    return (
        <>
            <IdvIntro title={title} desc={subtitle} />
            <IdvForm<T>
                initValues={(userProfile) => ({
                    firstName: userProfile?.firstName,
                    lastName: userProfile?.lastName,
                    phone: userProfile?.phone,
                    dob: userProfile?.dob,
                })}
                toMutationInput={(values) => values}
                backNextNavProps={{
                    backButtonText: 'Cancel',
                    showBackIcon: false,
                    onBack: () => modal.remove(),
                    onClickEventParams: { location: 'IDV > ProfileView' },
                }}
            >
                <IdvForm.Row>
                    <IdvForm.Input<T>
                        name="firstName"
                        label="Your legal first name"
                        placeholder="First name"
                        inputOptions={{ toUpperFirst: true }}
                        isRequired
                        autoFocus
                    />
                    <IdvForm.Input<T>
                        name="lastName"
                        label="Your legal last name"
                        placeholder="Last name"
                        inputOptions={{ toUpperFirst: true }}
                        isRequired
                    />
                </IdvForm.Row>
                <IdvForm.Row>
                    <IdvForm.Input<T>
                        name="phone"
                        label="Your phone number"
                        placeholder="(123) 456-7890"
                        type="phone"
                        isRequired
                        validateOnBlur
                        validations={[
                            {
                                validate: (value) => {
                                    const phoneValidation = new RegExp(
                                        /^\d{10}$/
                                    );
                                    return phoneValidation.test(
                                        digitsFromStr(value)
                                    );
                                },
                                error: 'Please enter a valid phone number',
                            },
                        ]}
                    />
                    <IdvForm.Input<T>
                        name="dob"
                        label="Your birthday"
                        type="date"
                        isRequired
                    />
                </IdvForm.Row>

                <IdvIntroDisclosure />
            </IdvForm>
        </>
    );
};
